export default __webpack_public_path__ + "static/media/cloud-upload.63b3fb12.svg";